import React, { useState, useRef, useMemo } from 'react'
import { isPc } from 'utils/utils'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Pagination } from 'swiper'
import Button, { ButtonGroup } from 'components/Base/Button'
import classnames from 'classnames'

import * as styles from './index.module.less'

interface dataProp {
  buttonText?: string
  desc?: string
  link?: string
  name?: string
  tagName?: string
  arrow_icon?: any
  tagWrap?: any
}
interface firstProps {
  buttonText?: string
  desc?: string
  link?: string
  name?: string
  poster?: any
  arrow_icon?: any
}
interface IntroduceProps {
  data?: dataProp[]
  firstData?: firstProps
}

export const Blog: React.FC<IntroduceProps> = ({ data, firstData }) => {
  const handleClick = (link) => {
    window.open(link)
  }
  return (
    <div
      className={classnames(
        'flex flex-wrap lg:justify-between mt-0 lg:mt-[60px] w-[33.4rem] lg:w-[1200px] mx-auto my-0',
      )}
    >
      <div
        className={classnames(
          'bg-[#fff] lg:bg-transparent rounded-[4px] w-[33.4rem] lg:w-[486px] cursor-pointer pb-[26px] lg:pb-auto',
          styles.blogFirst,
        )}
        onClick={() => handleClick(firstData?.link)}
      >
        <img src={firstData?.poster?.publicURL ?? firstData?.poster} />
        <p
          className={classnames(
            'text-[#1F2D3D] font-medium md:p-0 px-[1.3rem] pt-[1.3rem] text-[1.6rem] lg:text-[18px] lg:mt-[18px]',
            styles.name,
          )}
        >
          {firstData?.name}
        </p>
        <p
          className={classnames(
            'text-[#475669] pb-[2.6rem] lg:pb-0 px-[1.3rem] lg:px-0 text-[14px] mt-[1.8rem] lg:mt-[11px]',
            styles.firstDesc,
          )}
        >
          {firstData?.desc}
        </p>
        <p className={classnames('hidden lg:block lg:mt-[18px] text-[#04CB94]', styles.more)}>
          <span className="mr-[14px]">{firstData?.buttonText}</span>
          <img src={firstData?.arrow_icon?.publicURL ?? firstData?.arrow_icon} />
          <img src={firstData?.arrow_icon?.publicURL ?? firstData?.arrow_icon} />
        </p>
      </div>
      <ul className="flex mt-[1rem] w-[33.4rem] lg:mt-0 lg:jusity-between flex-wrap lg:w-[676px]">
        {data?.map((item, index) => (
          <li
            key={item.name}
            className={classnames(
              'bg-[#fff] lg:bg-transparent lg:p-[25px] w-[33.4rem] mb-[1rem] px-[1.3rem] lg:px-auto pt-[1.9rem] pb-[1.1rem] lg:pt-auto lg:mb-0 h-auto lg:w-[336px] lg:border-l lg:border-solid lg:border-[#D2D7DF] cursor-pointer',
              { 'lg:border-b': index === 0 || index === 1 },
              styles.blogList,
            )}
            onClick={() => handleClick(item?.link)}
          >
            <p
              className={classnames(
                'text-[#1F2D3D] text-[16px] lg:text-[18px] lg:mt-[18px]',
                styles.ellipsis,
                styles.name,
              )}
            >
              {item.tagName && (
                <span className="inline lg:hidden bg-[#DFF4F1] text-[#04CB94] py-[2px] px-[7px] text-[12px] mr-[1rem]">
                  {item.tagName}
                </span>
              )}
              <span className="font-medium md:ml-0">{item.name}</span>
              {item.tagName && (
                <span
                  className={classnames(
                    'hidden lg:inline-block align-middle bg-[#DFF4F1] text-[#04CB94] py-[2px] px-[7px] text-[12px]',
                    { 'ml-[6px]': item.tagWrap === true ? false : true },
                  )}
                >
                  {item.tagName}
                </span>
              )}
            </p>
            <p
              className={classnames(
                'whitespace-nowrap lg:whitespace-normal overflow-ellipsis overflow-hidden lg:h-[44px] text-[#475669] mt-[0.7rem] text-[14px] lg:mt-[11px]',
                styles.desc,
              )}
            >
              {item.desc}
            </p>
            <p className={classnames('hidden lg:inline-block lg:mt-[18px] text-[#04CB94]', styles.more)}>
              <span className="mr-[14px]">{item?.buttonText}</span>
              <img src={item?.arrow_icon?.publicURL ?? item?.arrow_icon} />
              <img src={item?.arrow_icon?.publicURL ?? item?.arrow_icon} />
            </p>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default Blog
